import { Component, Input, Output, EventEmitter, AfterViewInit, ViewChild} from '@angular/core';
import { SeAutocompleteComponent } from '@se/platform';



@Component({
    selector: 'se-autocomplete-cell-editor-popup',
    templateUrl: './autocomplete-cell-editor-popup.component.html',
    styleUrls: ['./autocomplete-cell-editor-popup.component.scss']
})
export class AutocompleteCellEditorPopupComponent implements AfterViewInit {
    /**
 * Current value of the cell
 * ngModel setted by AlphanumericCellEditorComponent
 */
    @Input() value: string;

    /**
     *  (Optional) it allows to specify if the filed is mandatory
     */
    @Input() required: boolean;

    /**
     * Event emitted when the value has been updated by the SeAutocomplete component is ready
     */
    @Output() updatedValue: EventEmitter<string> = new EventEmitter<string>();

    @Input() width: string;

    @Input() items: string[];


    @ViewChild('autocomplete') autocompRef: SeAutocompleteComponent;

    ngAfterViewInit() {
        setTimeout(() => {
            this.autocompRef.focus();
            this.autocompRef.select();
        }, 0);
    }


    updateValue(newValue: string): void {
        this.value = newValue;
        this.updatedValue.emit(this.value);
    }


    optionClicked(value: string) {
        this.updateValue(value);
    }
}
